import { render } from "./IconItemCategoryKitchen.vue?vue&type=template&id=9c1eda70"
import script from "./IconItemCategoryKitchen.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryKitchen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__